import React, { useRef, useState, useEffect } from "react";
import { t } from "i18next";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./sliderStyle.css";
import NewCard from "../../common/card/NewCard";
import scrollUp from "../../assets/images/scroll-up.png";
import { useNavigate } from "react-router-dom";
// import { useState } from "react";

function CarouselBlock(props) {
    const navigate = useNavigate();
    const carouselRef = useRef(null);
    const ButtonGroup = ({ next, previous, ...rest }) => {
        const {
            carouselState: { currentSlide, totalItems, slidesToShow }
        } = rest;
        return (
            <div className="carousel-button-group">
                <button aria-label="Go to previous slide"
                    className={currentSlide === 0 ? "prev-button disable-btn" : "prev-button"}
                    onClick={() => previous()}></button>
                <button aria-label="Go to next slide"
                    className={totalItems >= slidesToShow ? currentSlide === totalItems - slidesToShow ? "next-button disable-btn" : "next-button" : "next-button disable-btn"}
                    onClick={() => next()}></button>
            </div>
        );
    };

    const containerRef = useRef(null);
    // const [itemsToShow, setItemsToShow] = useState(0);
    const cardWidth = 334;
    const [itemsToShow, setItemsToShow] = useState(() =>
        Math.max(1, Math.floor((window.innerWidth - 550) / cardWidth))
    );

    

    useEffect(() => {
        if (!containerRef.current) return;

        const calculateItems = (width) => {
            return Math.max(1, Math.floor(width / cardWidth));
        };

        const updateItems = (width) => {
            setItemsToShow(calculateItems(width));
        };

        updateItems(containerRef.current.getBoundingClientRect().width)
        // observe container width changes
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                updateItems(entry.contentRect.width);
            }
        });

        resizeObserver.observe(containerRef.current);

        return () => resizeObserver.disconnect();
    }, []);

    // build responsive prop dynamically
    const responsive = {
        all: {
            breakpoint: { max: 4000, min: 0 },
            items: itemsToShow,
            slidesToSlide: itemsToShow
        },
    };

    return (
        <React.Fragment>
            <div className="carousel-container p-0" ref={containerRef}>
                <Carousel
                    responsive={responsive}
                    showDots={true}
                    keyBoardControl={true}
                    containerClass="carousel-container"
                    renderArrowsWhenDisabled={true}
                    arrows={false}
                    infinite={false}
                    ref={carouselRef}
                    customButtonGroup={
                        <ButtonGroup next={props.next} previous={props.previous} rest={props.rest} />
                    }
                >
                    {props.myLearningObj
                        ? [
                            ...props.myLearningObj
                                .filter((e) => !e.name.includes("DNS"))
                                .map((e) => (
                                    <NewCard
                                        className="m-4"
                                        key={e.id}
                                        componentName="MyLearning"
                                        data={e}
                                    />
                                )),
                            <div key="view-all" className="new-card" role="button" tabIndex={0} onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    navigate("/mylearning");
                                }
                            }} onClick={() => { navigate("/mylearning"); }}>
                                <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <span>
                                        <img src={scrollUp} alt="" style={{ transform: "rotate(90deg)", width: "40px" }}></img>
                                    </span>
                                    <h1 style={{ color: "#2799f6" }}>View All</h1>
                                </div>
                            </div>,
                        ]
                        : (
                            <h4 className="no-data">{t("no-courses-are-available")}</h4>
                        )}
                </Carousel>
            </div>
        </React.Fragment>
    );
}

export default CarouselBlock;